import { Dialog, DialogContent } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import SharePop from "../../components/common/shareLivestream";
import Modal from "../../components/Modal/Modal";
import { IsNullOrEmpty } from "../../helpers/utility";
import { getProductRequest } from "../../store/shopping/shopping.actions";
import { getProducts } from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { getImage, getUserProfile } from "../../store/user/user.selector";
import AddAddress from "../AccountPreferences/addAddress";
import ProductCard from "../livestream/product_card";

const MyStore = () => {
    const dispatch = useDispatch();
    const [shareVideo, setShareVideo] = useState(false);
    const [addProduct, setAddProduct] = useState(false);
    const [editProduct, setEditProduct] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [addAddress, setAddAddress] = useState(false);
    const navigate = useNavigate();

    const { products, userProfile, deliveryAddress, deliveryLoading } =
        useSelector((state) => {
            return {
                products: getProducts(state),
                userProfile: getUserProfile(state),
                deliveryAddress: getDeliveryAddresses(state),
                deliveryLoading: state.DeliveryAddressReducer.isLoading,
            };
        });

    useEffect(() => {
        setAddProduct(false);
    }, [products]);

    useEffect(() => {
        dispatch(getProductRequest(userProfile._id));
        dispatch(getDeliveryAddressRequest());
    }, []);

    let productList = products;

    if (!IsNullOrEmpty(searchText)) {
        productList = products.filter((item) => {
            return (
                item.code.toLowerCase().indexOf(searchText.toLowerCase()) >
                    -1 ||
                item.name.toLowerCase().indexOf(searchText.toLowerCase()) >
                    -1 ||
                item.descriptions
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    const shareUrl =
        process.env.REACT_APP_URL +
        "/" +
        userProfile.account.userName +
        "/profile/shop";

    productList = _.sortBy(productList, (x) =>
        moment(x.dateCreated).unix()
    ).reverse();

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full max-w-full overflow-hidden flex flex-col ">
            <div className="">
                {addAddress && (
                    <AddAddress onClose={() => setAddAddress(false)} />
                )}
                <div className="flex flex-col xs:flex-row gap-y-3 items-center justify-between mb-4">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        My store
                    </h2>
                    {productList.length > 0 && (
                        <div className="space-x-3 flex items-center">
                            <span onClick={() => setShareVideo(true)}>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                        stroke="#E38301"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                            <button
                                onClick={() => navigate("/page/viewStore")}
                                className="py-2.5 px-5 rounded-lg capitalize text-sm bg-white text-black-50 border border-black-10 font-medium"
                            >
                                View store as
                            </button>
                            <button
                                onClick={() => {
                                    if (deliveryAddress.length === 0) {
                                        Swal.fire({
                                            allowOutsideClick: false,
                                            title: "Add your address",
                                            text: "You haven’t added any shipping address yet please click below to add.",
                                            icon: "warning",
                                            iconHtml: `<img src="${require("../../assets/images/map.png")}" />`,
                                            confirmButtonText:
                                                "Add new address",
                                            showCancelButton: true,
                                            customClass: {
                                                cancelButton:
                                                    "order-1 right-gap",
                                                confirmButton: "order-2",
                                                denyButton: "order-3",
                                                icon: "custom-swal-icon",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                setAddAddress(true);
                                            }
                                            if (result.isDismissed) {
                                                setAddProduct(false);
                                            }
                                        });
                                    } else {
                                        setAddProduct(true);
                                    }
                                }}
                                className="py-2.5 px-5 rounded-lg capitalize text-sm bg-orange-color text-white border border-transparent font-bold"
                            >
                                Add product
                            </button>
                        </div>
                    )}
                </div>
                {productList.length > 0 && (
                    <div className="">
                        <div className="relative mb-3.5">
                            <input
                                type="search"
                                className="py-3.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-sm sm:text-sm outline-none"
                                placeholder="Search Products"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />

                            <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                        fill="black"
                                        fillOpacity="0.5"
                                    />
                                </svg>
                            </span>
                        </div>
                    </div>
                )}
            </div>

            {productList.length === 0 ? (
                <div className="text-center h-[70vh] text-lg text-black-50 flex text-center items-center justify-center flex-col">
                    <svg
                        width="150"
                        height="150"
                        viewBox="0 0 18 18"
                        className="stroke-current"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.25 16.5V10.25C10.25 10.0842 10.3159 9.92527 10.4331 9.80806C10.5503 9.69085 10.7093 9.625 10.875 9.625H13.375C13.5408 9.625 13.6997 9.69085 13.817 9.80806C13.9342 9.92527 14 10.0842 14 10.25V16.5M10.25 16.5H0.966679M10.25 16.5H14M14 16.5H17.0333M15.875 16.5V6.79083C16.2072 6.59909 16.4908 6.33349 16.7038 6.01459C16.9169 5.6957 17.0538 5.33205 17.1038 4.95179C17.1538 4.57154 17.1157 4.18487 16.9924 3.82171C16.869 3.45855 16.6638 3.12864 16.3925 2.8575L15.4008 1.86667C15.1667 1.63218 14.8489 1.50029 14.5175 1.5H3.48168C3.15027 1.50029 2.83254 1.63218 2.59835 1.86667L1.60751 2.85667C1.33688 3.12811 1.13219 3.45809 1.00924 3.82114C0.886282 4.1842 0.848342 4.57064 0.898343 4.95068C0.948343 5.33072 1.08495 5.6942 1.29763 6.01309C1.5103 6.33199 1.79337 6.59779 2.12501 6.79M2.12501 16.4992V6.79167C2.62503 7.07999 4.68075 6.17674 5.25033 6.08333C7.75033 8.16667 12.2917 6.7975 12.75 6.27833C13.1319 6.71112 13.6516 6.99852 14.2212 7.09178C14.7908 7.18504 15.3751 7.07842 15.875 6.79"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="my-2">
                        There is currently no product in your store. Start
                        listing your products for sale.
                    </span>
                    <button
                        onClick={() => {
                            if (deliveryAddress.length === 0) {
                                Swal.fire({
                                    allowOutsideClick: false,
                                    title: "Add your address",
                                    text: "You haven’t added any shipping address yet please click below to add.",
                                    icon: "warning",
                                    iconHtml: `<img src="${require("../../assets/images/map.png")}" />`,
                                    confirmButtonText: "Add new address",
                                    showCancelButton: true,
                                    customClass: {
                                        cancelButton: "order-1 right-gap",
                                        confirmButton: "order-2",
                                        denyButton: "order-3",
                                        icon: "custom-swal-icon",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        setAddAddress(true);
                                    }
                                    if (result.isDismissed) {
                                        setAddProduct(false);
                                    }
                                });
                            } else {
                                setAddProduct(true);
                            }
                        }}
                        className="py-2.5 px-5 rounded-lg capitalize text-sm bg-orange-color text-white border border-transparent font-bold"
                    >
                        Add product
                    </button>
                </div>
            ) : (
                <div className="overflow-y-auto flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5  pt-3.5">
                        {productList.map((x) => {
                            return (
                                <div className="p-4 border border-black-10 rounded-lg bg-white h-fit">
                                    <div className="mb-3">
                                        <ProductCard
                                            products={products}
                                            product={x}
                                            onClose={() => setAddProduct(false)}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {/* Share Profile Modal  */}
            <Modal show={shareVideo} onClose={() => setShareVideo(false)}>
                <SharePop
                    onClose={() => setShareVideo(false)}
                    shareUrl={shareUrl}
                    title={userProfile.fullName}
                    subTitle={userProfile.userName}
                    image={getImage(userProfile.avatar.attachments)}
                    heading="Share Store"
                />
            </Modal>

            {/* Add Product Modal  */}
            <Dialog open={addProduct} onClose={() => setAddProduct(false)}>
                <DialogContent>
                    <ProductCard
                        products={products}
                        product={{}}
                        isAdd={true}
                        onClose={() => setAddProduct(false)}
                    />
                </DialogContent>
            </Dialog>

            {/* Edit Product Modal  */}
            <Modal show={editProduct} onClose={() => setEditProduct(false)}>
                <ProductCard
                    products={products}
                    product={{}}
                    onClose={() => setEditProduct(false)}
                />
            </Modal>
        </div>
    );
};

export const StoreProducts = ({ storeImg }) => {
    return (
        <div className=" hidden">
            {storeImg ? (
                <div className="grid grid-cols-4 gap-2 mb-3">
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <img
                            src={storeImg}
                            alt=""
                            className="w-full h-full object-cover object-center rounded-md"
                        />
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <img
                            src={storeImg}
                            alt=""
                            className="w-full h-full object-cover object-center rounded-md"
                        />
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <img
                            src={storeImg}
                            alt=""
                            className="w-full h-full object-cover object-center rounded-md"
                        />
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md">
                        <img
                            src={storeImg}
                            alt=""
                            className="w-full h-full object-cover object-center rounded-md"
                        />
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-4 gap-2 mb-3">
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md flex justify-center items-center cursor-pointer">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.4993 0.416992C19.173 0.416992 24.5827 5.8267 24.5827 12.5003C24.5827 19.174 19.173 24.5837 12.4993 24.5837C5.82572 24.5837 0.416016 19.174 0.416016 12.5003C0.416016 5.8267 5.82572 0.416992 12.4993 0.416992ZM12.4993 6.45866C12.2804 6.45867 12.0688 6.53798 11.9037 6.68192C11.7387 6.82586 11.6313 7.0247 11.6016 7.24166L11.5931 7.36491V11.5941H7.36393C7.13432 11.5941 6.9133 11.6814 6.74552 11.8381C6.57774 11.9949 6.47572 12.2095 6.46007 12.4386C6.44442 12.6676 6.51631 12.8941 6.66121 13.0722C6.80611 13.2503 7.01321 13.3668 7.24068 13.3981L7.36393 13.4066H11.5931V17.6357C11.5932 17.8654 11.6804 18.0864 11.8371 18.2542C11.9939 18.4219 12.2085 18.524 12.4376 18.5396C12.6667 18.5553 12.8931 18.4834 13.0713 18.3385C13.2494 18.1936 13.3658 17.9865 13.3971 17.759L13.4056 17.6357V13.4066H17.6348C17.8644 13.4065 18.0854 13.3193 18.2532 13.1625C18.421 13.0058 18.523 12.7912 18.5386 12.5621C18.5543 12.333 18.4824 12.1065 18.3375 11.9284C18.1926 11.7503 17.9855 11.6338 17.758 11.6025L17.6348 11.5941H13.4056V7.36491C13.4056 7.12456 13.3101 6.89405 13.1402 6.72409C12.9702 6.55414 12.7397 6.45866 12.4993 6.45866Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md flex justify-center items-center cursor-pointer">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.4993 0.416992C19.173 0.416992 24.5827 5.8267 24.5827 12.5003C24.5827 19.174 19.173 24.5837 12.4993 24.5837C5.82572 24.5837 0.416016 19.174 0.416016 12.5003C0.416016 5.8267 5.82572 0.416992 12.4993 0.416992ZM12.4993 6.45866C12.2804 6.45867 12.0688 6.53798 11.9037 6.68192C11.7387 6.82586 11.6313 7.0247 11.6016 7.24166L11.5931 7.36491V11.5941H7.36393C7.13432 11.5941 6.9133 11.6814 6.74552 11.8381C6.57774 11.9949 6.47572 12.2095 6.46007 12.4386C6.44442 12.6676 6.51631 12.8941 6.66121 13.0722C6.80611 13.2503 7.01321 13.3668 7.24068 13.3981L7.36393 13.4066H11.5931V17.6357C11.5932 17.8654 11.6804 18.0864 11.8371 18.2542C11.9939 18.4219 12.2085 18.524 12.4376 18.5396C12.6667 18.5553 12.8931 18.4834 13.0713 18.3385C13.2494 18.1936 13.3658 17.9865 13.3971 17.759L13.4056 17.6357V13.4066H17.6348C17.8644 13.4065 18.0854 13.3193 18.2532 13.1625C18.421 13.0058 18.523 12.7912 18.5386 12.5621C18.5543 12.333 18.4824 12.1065 18.3375 11.9284C18.1926 11.7503 17.9855 11.6338 17.758 11.6025L17.6348 11.5941H13.4056V7.36491C13.4056 7.12456 13.3101 6.89405 13.1402 6.72409C12.9702 6.55414 12.7397 6.45866 12.4993 6.45866Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md flex justify-center items-center cursor-pointer">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.4993 0.416992C19.173 0.416992 24.5827 5.8267 24.5827 12.5003C24.5827 19.174 19.173 24.5837 12.4993 24.5837C5.82572 24.5837 0.416016 19.174 0.416016 12.5003C0.416016 5.8267 5.82572 0.416992 12.4993 0.416992ZM12.4993 6.45866C12.2804 6.45867 12.0688 6.53798 11.9037 6.68192C11.7387 6.82586 11.6313 7.0247 11.6016 7.24166L11.5931 7.36491V11.5941H7.36393C7.13432 11.5941 6.9133 11.6814 6.74552 11.8381C6.57774 11.9949 6.47572 12.2095 6.46007 12.4386C6.44442 12.6676 6.51631 12.8941 6.66121 13.0722C6.80611 13.2503 7.01321 13.3668 7.24068 13.3981L7.36393 13.4066H11.5931V17.6357C11.5932 17.8654 11.6804 18.0864 11.8371 18.2542C11.9939 18.4219 12.2085 18.524 12.4376 18.5396C12.6667 18.5553 12.8931 18.4834 13.0713 18.3385C13.2494 18.1936 13.3658 17.9865 13.3971 17.759L13.4056 17.6357V13.4066H17.6348C17.8644 13.4065 18.0854 13.3193 18.2532 13.1625C18.421 13.0058 18.523 12.7912 18.5386 12.5621C18.5543 12.333 18.4824 12.1065 18.3375 11.9284C18.1926 11.7503 17.9855 11.6338 17.758 11.6025L17.6348 11.5941H13.4056V7.36491C13.4056 7.12456 13.3101 6.89405 13.1402 6.72409C12.9702 6.55414 12.7397 6.45866 12.4993 6.45866Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>
                    <div className=" h-[74px] border border-[ #D1D5DB] rounded-md flex justify-center items-center cursor-pointer">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.4993 0.416992C19.173 0.416992 24.5827 5.8267 24.5827 12.5003C24.5827 19.174 19.173 24.5837 12.4993 24.5837C5.82572 24.5837 0.416016 19.174 0.416016 12.5003C0.416016 5.8267 5.82572 0.416992 12.4993 0.416992ZM12.4993 6.45866C12.2804 6.45867 12.0688 6.53798 11.9037 6.68192C11.7387 6.82586 11.6313 7.0247 11.6016 7.24166L11.5931 7.36491V11.5941H7.36393C7.13432 11.5941 6.9133 11.6814 6.74552 11.8381C6.57774 11.9949 6.47572 12.2095 6.46007 12.4386C6.44442 12.6676 6.51631 12.8941 6.66121 13.0722C6.80611 13.2503 7.01321 13.3668 7.24068 13.3981L7.36393 13.4066H11.5931V17.6357C11.5932 17.8654 11.6804 18.0864 11.8371 18.2542C11.9939 18.4219 12.2085 18.524 12.4376 18.5396C12.6667 18.5553 12.8931 18.4834 13.0713 18.3385C13.2494 18.1936 13.3658 17.9865 13.3971 17.759L13.4056 17.6357V13.4066H17.6348C17.8644 13.4065 18.0854 13.3193 18.2532 13.1625C18.421 13.0058 18.523 12.7912 18.5386 12.5621C18.5543 12.333 18.4824 12.1065 18.3375 11.9284C18.1926 11.7503 17.9855 11.6338 17.758 11.6025L17.6348 11.5941H13.4056V7.36491C13.4056 7.12456 13.3101 6.89405 13.1402 6.72409C12.9702 6.55414 12.7397 6.45866 12.4993 6.45866Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>
                </div>
            )}
            <p className="text-extraSmall text-black-50">
                You can select upto 4 media files- images, videos
            </p>
        </div>
    );
};

export default MyStore;
